import axios from 'axios';
import { IUserOtpRequest } from '@/shared/model/user-otp.model';

interface IUserOtpValidationResponse {
  valid: boolean;
  message: string;
}

const baseApiUrl = 'api/user-otp';

export default class UserOtpService {
  public generateOtp(request: IUserOtpRequest): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, request)
        .then(() => resolve())
        .catch(err => reject(err));
    });
  }

  public validateOtp(request: IUserOtpRequest): Promise<IUserOtpValidationResponse> {
    return axios.post(`${baseApiUrl}/validate`, request).then(res => res.data as IUserOtpValidationResponse);
  }
}
